export enum DocumentType {
  PASSPORT = 'PASSPORT',
  WORKPASS = 'WORKPASS',
  NRICFIN = 'NRICFIN', // same ase SV_NUMBER
}
